// extracted by mini-css-extract-plugin
export var externalLink = "_dy-0";
export var internalLinkLabel = "_dy-1";